export default __webpack_public_path__ + "static/media/dreamycreations.09eaa120.svg";